export const environment = {
  production: true,
  baseUrl: 'https://www.weld-op.com/api',
  baseTmaxxUrl: 'http://46.31.149.179:8088',
  orchUrl: 'https://search.weld-op.com'
};